module.exports = __webpack_public_path__ + "img/BAWS_Shield3_1_1.ac8894bd.png";